import { AppointmentsRequestInterface } from '../../../interfaces/request/appointments/appointments-request-interface';

export class CpAppointmentsRequestModel implements AppointmentsRequestInterface {
  CardNumber: string = '';
  StartDate: string = '';
  EndDate: string = '';
  PageSize: number = 5;
  Page: number = 1;
  ClaimType: string = '';

  constructor(init?: Partial<CpAppointmentsRequestModel>) {
    Object.assign(this, init);
  }
}
